import Vue from 'vue'
import configs from '@/config'

// BOO-630 — marketplace license admin CRUD. Talks to the general-api admin
// endpoints under /api/admin/marketplace-licenses. Auth is the global
// ahaTokenAdmin Bearer header set in router.beforeEach — nothing per-call.
let resource = null
const licensePath = `${configs.baseUrl}/api/admin/marketplace-licenses`

const actions = {
  list: {
    method: 'GET',
    url: licensePath,
  },
  products: {
    method: 'GET',
    url: `${licensePath}/products`,
  },
  create: {
    method: 'POST',
    url: licensePath,
  },
  revoke: {
    method: 'POST',
    url: `${licensePath}/{id}/revoke`,
  },
  remove: {
    method: 'DELETE',
    url: `${licensePath}/{id}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// Returns { data: [...], pagination: { total, page, limit, totalPages } }.
const listLicenses = async (params) => {
  const res = await resource.list(params)
  return res.body
}

// Returns { data: [{ productId, name, planKey }] } — the lifetime Stripe products
// a license can grant, for the create-modal Stripe Product picker.
const listProducts = async () => {
  const res = await resource.products()
  return res.body
}

// Returns { license }. Rejects (vue-resource) on 400/409 with error.body.error.
const createLicense = async (params) => {
  const res = await resource.create({}, params)
  return res.body
}

// Returns { ok, code, downgraded }. Rejects on 404.
const revokeLicense = async (id) => {
  const res = await resource.revoke({ id }, {})
  return res.body
}

// Hard-delete the license record. Returns { ok, deletedId }. Rejects on 404.
const deleteLicense = async (id) => {
  const res = await resource.remove({ id })
  return res.body
}

export default {
  initResource,
  listLicenses,
  listProducts,
  createLicense,
  revokeLicense,
  deleteLicense,
}
